<template>
  <!-- Main Sidebar Container -->
  <div class="sidebar-container">
    <aside class="main-sidebar sidebar-light-danger elevation-2 hemolife-sidebar">
      <router-link to="/" class="brand-link text-center hemolife-brand-link">
        <img
          :src="logoUrl"
          alt="Logo de la organización"
          class="brand-image logo-xl hemolife-brand-logo-xl"
        />
        <span class="brand-text font-weight-bold hemolife-brand-subtitle">
          Fundación Banco Nacional de Sangre
        </span>
        <img
          :src="logoUrl"
          alt=""
          class="brand-image logo-xs hemolife-brand-logo-xs"
          width="40"
          height="40"
        />
      </router-link>

      <!-- Sidebar -->
      <div class="sidebar">
        <!-- SidebarSearch Form -->
        <div class="form-inline">
          <div class="input-group mt-2">
            <input
              class="form-control form-control-sidebar"
              type="search"
              placeholder="Buscar en menú…"
              aria-label="Buscar en menú"
              v-model="filtro"
            />
            <div class="input-group-append">
              <button class="btn btn-sidebar">
                <i class="fas fa-search fa-fw"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Sidebar Menu -->
        <nav class="mt-2">
          <ul
            class="nav nav-pills nav-sidebar flex-column nav-child-indent"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
          >
            <li class="nav-item" v-for="menu in filterMenu" :key="menu.id">
              <a href="#" class="nav-link active">
                <i class="nav-icon" :class="menu.icono"></i>
                <p class="text-black">
                  {{ menu.nombre }}
                  <i class="right fas fa-angle-left"></i>
                </p>
              </a>
              <ul class="nav nav-treeview pl-2" v-if="menu.nivel2.length > 0">
                <li
                  class="nav-item"
                  v-for="nivel2 in menu.nivel2"
                  :key="nivel2.id"
                >
                  <router-link
                    :to="nivel2.ruta"
                    class="nav-link"
                    :class="$route.fullPath == nivel2.ruta ? 'active' : ''"
                  >
                    <i class="nav-icon" :class="nivel2.icono"></i>
                    <p class="">{{ nivel2.nombre }}</p>
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        <!-- /.sidebar-menu -->
      </div>
      <!-- /.sidebar -->
      <div class="sidebar-footer brand-link text-center hemolife-sidebar-footer">
        <a href="https://hemolifeamerica.org/" target="_blank" rel="noopener noreferrer">
          <img
            :src="logoUrl"
            alt="Logo de la organización"
            style="width: 80px; opacity: 0.8"
          />
        </a>
      </div>
    </aside>
  </div>
</template>

<script>
import clienteLogo from "../../services/clienteLogo";

export default {
  name: "NavBarLeft",

  data() {
    return {
      filtro: "",
      /* cliente: this.$store.getters.getUser.cliente, */
    };
  },
  computed: {
    logoUrl() {
      return clienteLogo(this.$store.getters.getUser);
    },

    filterMenu() {
      if (this.$store.state.menus) {
        return this.$store.state.menus
          .map((res1) => {
            const nuevosNiveles2 = res1.nivel2
              .map((res2) => {
                const nMenu = res2.nombre.toString().toLowerCase();
                const search = this.filtro.toLowerCase();
                return nMenu.includes(search) ? res2 : null;
              })
              .filter(Boolean); // Filtra los elementos nulos

            return nuevosNiveles2.length > 0
              ? { ...res1, nivel2: nuevosNiveles2 }
              : null;
          })
          .filter(Boolean); // Filtra los elementos nulos
      } else {
        return this.$store.state.menus;
      }
    },
  },
};
</script>

<style>
.sidebar-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sidebar {
  position: relative;
  flex: 1;
  max-height: calc(88% - 130px);
  overflow-y: auto;
}

.hemolife-sidebar.main-sidebar {
  border-right: 1px solid rgba(78, 105, 144, 0.12);
  box-shadow: 2px 0 18px rgba(15, 23, 42, 0.06);
  background: #fdfefe;
}

.hemolife-sidebar .brand-link {
  border-bottom: 1px solid rgba(78, 105, 144, 0.1);
  padding-top: 14px;
  padding-bottom: 14px;
}

/* AdminLTE usa position:absolute en logo-xl/xs; aquí alineamos con marca centrada en columna */
.hemolife-sidebar .hemolife-brand-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.hemolife-sidebar .hemolife-brand-link .brand-image.logo-xl,
.hemolife-sidebar .hemolife-brand-link .brand-image.logo-xs {
  float: none;
  position: relative;
  left: auto;
  top: auto;
  margin-left: 0;
  margin-right: 0;
  max-height: none;
}

.hemolife-sidebar .hemolife-brand-logo-xl {
  width: 140px;
  max-width: 100%;
  height: auto;
}

.hemolife-sidebar .hemolife-brand-logo-xs {
  width: 40px;
  height: auto;
  object-fit: contain;
}

/* Sin hueco extra: el icono mini solo participa en el layout cuando el sidebar está colapsado */
body:not(.sidebar-collapse) .hemolife-sidebar .hemolife-brand-link .logo-xs {
  display: none !important;
}

.hemolife-sidebar .hemolife-brand-subtitle {
  display: block;
  font-size: 14px;
  line-height: 1.25;
  margin-top: 0.5rem;
  max-width: 220px;
}

/* Pie: sin duplicar marca en barra estrecha; al expandir al hover, sí */
@media (min-width: 992px) {
  .sidebar-mini-xs.sidebar-collapse .hemolife-sidebar .hemolife-sidebar-footer {
    display: none;
  }

  .sidebar-mini-xs.sidebar-collapse
    .hemolife-sidebar.main-sidebar:hover
    .hemolife-sidebar-footer,
  .sidebar-mini-xs.sidebar-collapse
    .hemolife-sidebar.main-sidebar.sidebar-focused
    .hemolife-sidebar-footer {
    display: block;
  }
}

.hemolife-sidebar .form-control-sidebar {
  border-radius: 10px 0 0 10px;
  border: 1px solid #dfe7f2;
  background: #f8fafc;
}

.hemolife-sidebar .form-control-sidebar:focus {
  border-color: #4e6990;
  box-shadow: 0 0 0 2px rgba(78, 105, 144, 0.15);
}

.hemolife-sidebar .btn-sidebar {
  border-radius: 0 10px 10px 0;
  border: 1px solid #dfe7f2;
  border-left: none;
  background: linear-gradient(135deg, #4e6990, #3d5f82);
  color: #fff;
}

.hemolife-sidebar .btn-sidebar:hover {
  color: #fff;
  filter: brightness(1.05);
}

.hemolife-sidebar .nav-sidebar > .nav-item > .nav-link {
  border-radius: 8px;
  margin: 2px 8px;
}

.hemolife-sidebar .nav-sidebar .nav-link.active,
.hemolife-sidebar .nav-sidebar .nav-link:hover {
  background: rgba(78, 105, 144, 0.07);
}

.hemolife-sidebar .nav-treeview > .nav-item > .nav-link.active {
  background: linear-gradient(
    90deg,
    rgba(229, 53, 56, 0.12),
    rgba(78, 105, 144, 0.06)
  ) !important;
  color: #1e293b !important;
  border-left: 3px solid #e53538;
  border-radius: 0 8px 8px 0;
  font-weight: 600;
}

.hemolife-sidebar .nav-treeview .nav-link {
  padding-left: 1.35rem;
}

.hemolife-sidebar .sidebar-footer {
  border-top: 1px solid rgba(78, 105, 144, 0.1);
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>

